<button
  [type]="type"
  class="button"
  [disabled]="btnDisabled"
  [ngClass]="{
    'button-primary': color === 'primary',
    'button-secondary': color === 'secondary',
    'button-facebook': color === 'facebook',
    'button-small': size === 'small',
    'button-large': size === 'large',
    'button-block': size === 'block',
    'button-no-hover': noHover
  }"
  (click)="clickEvent()">
  <ng-content></ng-content>
</button>